import { PageContainer, PageHeader } from '@/components/Atoms'
import { Card, CardContent } from '@/components/Card'
import { unreleasedMaterialsSearchSchema } from '@/hooks/queries/crt/useUnreleasedMaterials'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { UnreleasedMaterialsDataTable } from './-components/UnreleasedMaterialsDataTable'

export const Route = createFileRoute(
  '/_auth/_modules/crt/materials/insights/unreleased-materials/',
)({
  component: RouteComponent,
  validateSearch: (search) => unreleasedMaterialsSearchSchema.parse(search),
})

function RouteComponent() {
  const { t } = useTranslation('crt')

  return (
    <PageContainer maxWidth="wide">
      <PageHeader>{t('unreleasedMaterials.pageHeader')}</PageHeader>

      <Card>
        <CardContent className="pt-6">
          <UnreleasedMaterialsDataTable />
        </CardContent>
      </Card>
    </PageContainer>
  )
}
